import * as Yup from "yup";

// ** Regex patterns
// const urlRegex = /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(\/\S*)?$/;

// ** User extra details form validation schema
export const UserDetailsSchema = Yup.object().shape({
  username: Yup.string()
    .min(4, "Username is too short!")
    .max(20, "Username is too long!")
    .required("Username is required")
    .matches(
      /^[a-zA-Z0-9_ ]+$/,
      "Username can only contain letters, numbers, and underscores."
    ),

  website: Yup.string().url(
    "Please enter a valid URL, e.g., https://example.com or http://example.com"
  ),

  /*website: Yup.string()
        .matches(urlRegex, "Please enter a valid URL")
        .required("Website is required"),*/

  jobTitle: Yup.string()
    .min(2, "Job title is too short!")
    .max(50, "Job title is too long!"),

  department: Yup.string()
    .min(2, "Department/ Research name is too short!")
    .max(50, "Department/ Research name is too long!")
    .required("Department/ Research group name is required"),

  aboutYou: Yup.string().max(500, "About you section is too long!"),

  institute_name: Yup.string().max(50, "Institute name is too long!"),
});

// ** project update form validation schema// this should be date
export const ProjectUpdateSchema = Yup.object().shape({
  name: Yup.string()
    .required("Name is required")
    .max(255, "Name cannot be more than 255 characters"),
  description: Yup.string().required("Description is required"),
  start_date: Yup.string().trim().nullable().required("Start date is required"),
  end_date: Yup.string().trim().nullable().required("End date is required"),
});

// ** workStream update form validation schema for creating updating a workStream
export const WorkStreamDataSchema = ProjectUpdateSchema;

// ** Register form validations schema
export const RegisterSchema = Yup.object().shape({
  firstName: Yup.string().trim().required("First Name is required"),
  lastName: Yup.string().trim().required("Last Name is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  password: Yup.string()
    .min(8, "Password must be at least 8 characters")
    .required("Password is required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Confirm Password is required"),
});

// ** Login form validation schema
export const LoginSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Email is required"),
  password: Yup.string().required("Password is required"),
});

// ** task create/update form validation schema
export const TaskCreateUpdateSchema = Yup.object().shape({
  title: Yup.string().required("Title is required")
  .max(255, "Title cannot be more than 255 characters"),
  priorities: Yup.object().nullable().required("Priority is required"),
  description: Yup.string().required("Description is required"),
  due_date: Yup.date()
    .nullable()
    .required("Due date is required") // min time is current time
    .min(
      new Date(new Date().setHours(0, 0, 0, 0)),
      "Due date must be in the future"
    ),
});

// ** organization validation schema for creating a new organization

export const organizationValidationSchema = Yup.object().shape({
  name: Yup.string().trim().required("Name is required"),
  description: Yup.string().trim().required("Description is required"),
});

// ** project validation schema for creating a new project
export const projectValidationSchema = organizationValidationSchema;

// ** role validation schema for adding a new member to an organization
export const memberRoleValidationSchema = Yup.object().shape({
  email: Yup.string()
    .trim()
    .lowercase()
    .email("Please enter a valid email address")
    .required("Email is required"),
  role: Yup.string().required("Role is required"),
});

// Validation schema
export const projectMemberRoleValidationSchema = Yup.object().shape({
  email: Yup.string()
    .email("*Invalid email address")
    .required("*Email is required"),
  role: Yup.string()
    .oneOf(["admin", "contributor"], "*Invalid role")
    .required("*Role is required"),
});

// ** Risk validation schema for creating a new risk
export const riskValidationSchema = Yup.object().shape({
  title: Yup.string().required("Title is required")
  .max(255, "Title cannot be more than 255 characters"),
  task_ids: Yup.array().min(1, "Select at least one task"),
  description: Yup.string().required("Description is required"),
});

// ** Lesson validation schema for creating a new lesson
export const lessonValidationSchema = Yup.object().shape({
  title: Yup.string().required("Title is required")
  .max(255, "Title cannot be more than 255 characters"),
  task_id: Yup.string().required("Select a task"),
  description: Yup.string().required("Description is required"),
});

export const noteValidationSchema = Yup.object().shape({
  title: Yup.string().required("Title is required")
  .max(255, "Title cannot be more than 255 characters"),
  note: Yup.string().required("Note is required"),
});

//user profile update form validation schema
export const UpdateUserSchema = Yup.object().shape({
  username: Yup.string()
    .min(4, "Username is too short!")
    .max(20, "Username is too long!")
    .required("Username is required")
    .matches(
      /^[a-zA-Z0-9_ ]+$/,
      "Username can only contain letters, numbers, and underscores."
    ),

  first_name: Yup.string()
    .min(2, "First name is too short!")
    .max(30, "First name is too long!")
    .required("First name is required")
    .matches(
      /^[a-zA-Z\s'-]+$/,
      "First name can only contain letters, spaces, apostrophes, and hyphens."
    ),

  last_name: Yup.string()
    .min(2, "Last name is too short!")
    .max(30, "Last name is too long!")
    .required("Last name is required")
    .matches(
      /^[a-zA-Z\s'-]+$/,
      "Last name can only contain letters, spaces, apostrophes, and hyphens."
    ),

  website: Yup.string().url(
    "Please enter a valid URL, e.g., https://example.com or http://example.com"
  ),

  jobTitle: Yup.string()
    .min(2, "Job title is too short!")
    .max(50, "Job title is too long!"),

  department: Yup.string()
    .min(2, "Department/ Research name is too short!")
    .max(50, "Department/ Research name is too long!")
    .required("Department/ Research group name is required"),

  aboutYou: Yup.string().max(500, "About you section is too long!"),

  institute_name: Yup.string().max(50, "Institute name is too long!"),
});
